import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { isMediaMax, mediaMax, spacing } from 'presentations/views/styles';
import Image from 'presentations/views/components/atoms/Image';

const SlideShow = () => {
  const isMobile = isMediaMax('smartphone');
  let width = 112;
  let height = 219;
  if (!isMobile) {
    width = 224;
    height = 438;
  }
  return (
    <SlideList>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp01.png"
          alt="Meeting"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp02.png"
          alt="Sales"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp03.png"
          alt="Recruitment"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp04.png"
          alt="Education"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp05.png"
          alt="Workshop"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
      <Slide>
        <SlideImage
          src="pages/top/top_mv_sp06.png"
          alt="Conference"
          width={width}
          height={height}
          dpr={2}
          loading="auto"
        />
      </Slide>
    </SlideList>
  );
};

export default function Component() {
  return (
    <SliderWrapper>
      <SlideShow />
      <SlideShow />
      <SlideShow />
    </SliderWrapper>
  );
}
const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;
const SlideAnimation = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;
const SlideList = styled.div`
  display: flex;
  animation: ${SlideAnimation} 60s infinite linear 1s both;
`;
const Slide = styled.div`
  margin-right: ${spacing(24)};
  ${mediaMax.smartphone} {
    margin-right: ${spacing(8)};
  }
`;
const SlideImage = styled(Image)`
  width: 224px;
  height: 438px;
  ${mediaMax.smartphone} {
    width: 112px;
    height: 219px;
  }
`;
